<template>
  <div style="padding-top: 0.4rem">
    <div>我们检测到你可能使用了IE内核的浏览器进行访问，这会影响到页面的正常显示和功能使用。推荐使用谷歌和火狐浏览器，同时360、搜狗、QQ等浏览器的极速模式，也可以正常使用。</div>
  </div>
</template>

<script>
export default {
  created() {
    document.title = '麦德通'
  }
}
</script>


// WEBPACK FOOTER //
// src/views/no.vue